import { render, staticRenderFns } from "./retention.vue?vue&type=template&id=2829bea8&scoped=true"
import script from "./retention.vue?vue&type=script&lang=ts"
export * from "./retention.vue?vue&type=script&lang=ts"
import style0 from "./retention.vue?vue&type=style&index=0&id=2829bea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2829bea8",
  null
  
)

export default component.exports